import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GRID_SIDEBAR_CONFIG } from 'src/app/helpers/ag-grid/grid-sidebar.config';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GridSidebarEventsService } from 'src/@vex/services/grid.sidebar.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'toolbar-grid-sidebar',
  imports: [MatSlideToggleModule, FormsModule],
  templateUrl: './toolbar-grid-sidebar.component.html',
  styleUrl: './toolbar-grid-sidebar.component.scss',
})
export class ToolbarGridSidebarComponent {

  sidebarOnRight = true;
  sidebarTitle = 'Sidebar on Right';
  toggleColor: 'primary' | 'accent' = 'accent';

  constructor(private sidebarEvents: GridSidebarEventsService) {}

  ngOnInit() {
    const currentSidebar = this.sidebarEvents.getCurrentSidebar();

    this.sidebarOnRight = currentSidebar.position === 'right';
    this.updateUILabels();
  }

  toggleSidebarPosition() {
    this.updateUILabels();

    const config = {
      ...GRID_SIDEBAR_CONFIG,
      position: this.sidebarOnRight ? 'right' : 'left'
    };

    this.sidebarEvents.emitSidebarConfig(config);
  }

  private updateUILabels() {
    this.sidebarTitle = this.sidebarOnRight
      ? 'Sidebar on Right'
      : 'Sidebar on Left';

    this.toggleColor = this.sidebarOnRight
      ? 'accent'
      : 'primary';
  }
}
